import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  text: {
    fontWeight: 400,
    fontSize: 14,
    marginBottom: 4,
  },
  textActive: {
    fontWeight: 700,
  },
  textDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  button: {
    borderWidth: 2,
    borderColor: 'transparent',
  },
  buttonInner: {
    alignItems: 'center',
    gap: 8,
  },
  buttonActive: {
    borderColor: brand.main.water,
  },
  buttonFocus: {
    borderColor: FOCUS_COLOR,
  },
  image: {
    height: 92,
    width: 102,
    borderWidth: 2,
    borderColor: 'transparent',
    borderRadius: 10,
  },
  imageActive: {
    borderColor: brand.main.water,
  },
  imageDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  imagePlaceholder: {
    borderColor: neutrals.neutralGrays.dust,
  },
  subTag: {
    backgroundColor: brand.main.mustard,
    paddingHorizontal: 6,
    paddingVertical: 3,
    gap: 4,
    borderRadius: 36,
    position: 'absolute',
    top: 4,
    left: 4,
    zIndex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  subTagText: {
    fontWeight: 700,
    fontSize: 10,
    lineHeight: 14,
    letterSpacing: 0,
    color: neutrals.white,
  },
  icon: {
    width: 8,
    height: 8,
  },
});
